import { Observable } from 'rxjs';
import { publishReplay, refCount } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import {HttpClientService} from '../httpClient/httpclient.service';
import {Certification} from '../../models/certification.model';
import 'rxjs/Rx';
import { MessageService } from 'primeng/api';


@Injectable()
export class CertificationService {


  certifications: Certification[];
  certificationEditing: Certification;

  private cachedFields: Observable<any>

  constructor (
    private h: HttpClientService,
    private messageService: MessageService
  ) { }

  getAll() {
    return this.h.get('/koncentro-common/certification/certifications')
      .map(res => {
        return this.certifications = res;
      });
  }

  delete(record) {
    return this.h.delete('/koncentro-common/certification/certifications/' + record.id)
      .map(res => {
        this.certifications.splice(this.certifications.indexOf(record), 1);
        this.messageService.add({severity: 'info', summary: 'Confirmed', detail: 'Certification deleted'});
      });
  }

  post(newData) {
    return this.h.post('/koncentro-common/certification/certifications/', newData)
      .map(res => {
        newData.id = res.id;
        this.certifications.push(newData);
        this.messageService.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });

  }

  put(newData) {
    return this.h.put('/koncentro-common/certification/certifications/' + newData.id, newData)
      .map(res => {
        Object.assign(this.certificationEditing, newData);
        this.messageService.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });
  }

  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.h.get('/koncentro-common/schema/CertificationDto').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/certification/certification.service.ts